import { BaseModel } from '@fry/lib/store';

export class Blueprint extends BaseModel {

}
